import React, { useEffect, useState } from "react";
import { Fab, useMediaQuery } from "@mui/material";
import { KeyboardArrowUp } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

const ScrollToTopMobile = () => {
  const [visible, setVisible] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleScroll = () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    setVisible(scrollTop > 100);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    if (isMobile) {
      window.addEventListener("scroll", handleScroll);
    }
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isMobile]);

  if (!isMobile || !visible) return null;

  return (
    <Fab
      color="primary"
      onClick={scrollToTop}
      sx={{
        position: "fixed",
        bottom: 16,
        right: 16,
        zIndex: 999,
        boxShadow: 3,
      }}
    >
      <KeyboardArrowUp />
    </Fab>
  );
};

export default ScrollToTopMobile;
